import { useState, useEffect } from "react";
import { Modal, Button, Form, Row, Col, ToggleButton } from "react-bootstrap";

import { main_link } from "../Connection/Connection";
import useFetch from "../Fetch_Folder/useFetch";

function ViewLogs(props) {
  const show = props.show;
  const setShow = props.setShow;
  const selected_log = props.log_id;
  const user = JSON.parse(sessionStorage.getItem("user-data"));
  const user_id = user?.encrypted_id;

  // const {
  //   error,
  //   isLoading,
  //   data: selected_log,
  // } = useFetch(`${main_link}selectLog?user_id=${user_id}&log_id=${log_id}`);

  const [action, setAction] = useState();
  const [description, setDescription] = useState();
  const [ip, setIp] = useState();
  const [user_agent, setUser_agent] = useState();
  const [created_at_at, setCreated_at_at] = useState();
  const [created_since, setCreated_sine] = useState();
  const [created_by, setCreated_by] = useState();

  useEffect(() => {
    // console.log(selected_log);
    if (selected_log) {
      setAction(selected_log.action || "");
      setDescription(selected_log.description || "");
      setIp(selected_log.ip_address || "");
      setUser_agent(selected_log.user_agent || "");
      setCreated_at_at(selected_log.created_at_at || "");
      setCreated_sine(selected_log.created_since || "");
      setCreated_by(selected_log.created_by || "");
    }
  }, [selected_log]);
  return (
    <>
      <Modal
        show={show}
        onHide={() => setShow(false)}
        keyboard={false}
        size="lg"
      >
        <Modal.Header closeButton className="bg-secondary">
          <Modal.Title>Log Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col>
              <Form.Group className="mb-3" controlId="formBasicPassword">
                <Form.Label>Action</Form.Label>
                <Form.Control type="text" value={action} readOnly />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group className="mb-3" controlId="formBasicPassword">
                <Form.Label>Ip Address</Form.Label>
                <Form.Control type="text" value={ip} readOnly />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group className="mb-3" controlId="formBasicPassword">
                <Form.Label>Created By</Form.Label>
                <Form.Control type="text" value={created_by} readOnly />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col>
              <Form.Group className="mb-3" controlId="formBasicPassword">
                <Form.Label>Created AT</Form.Label>
                <Form.Control type="text" value={created_at_at} readOnly />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group className="mb-3" controlId="formBasicPassword">
                <Form.Label>Created From</Form.Label>
                <Form.Control type="text" value={created_since} readOnly />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col>
              <Form.Group className="mb-3" controlId="formBasicPassword">
                <Form.Label>User Agent</Form.Label>
                <Form.Control
                  as="textarea"
                  value={user_agent}
                  readOnly
                  rows={5}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col>
              <Form.Group className="mb-3" controlId="formBasicPassword">
                <Form.Label>Details</Form.Label>
                <Form.Control
                  as="textarea"
                  value={description}
                  readOnly
                  rows={5}
                />
              </Form.Group>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShow(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default ViewLogs;
